import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

import { useOsService } from '@/services/OsService/OsService';
import SettingsGeneralLinux from './OS/settings-general.linux.vue';
import SettingsGeneralWindows from './OS/settings-general.windows.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'settingsGeneral',
  setup(__props) {

const osService = useOsService();

return (_ctx: any,_cache: any) => {
  return (_unref(osService)?.isUnix.value)
    ? (_openBlock(), _createBlock(SettingsGeneralLinux, _normalizeProps(_mergeProps({ key: 0 }, (_ctx.$attrs as any))), null, 16))
    : (_unref(osService)?.isWindows.value)
      ? (_openBlock(), _createBlock(SettingsGeneralWindows, _normalizeProps(_mergeProps({ key: 1 }, (_ctx.$attrs as any))), null, 16))
      : _createCommentVNode("", true)
}
}

})